import type { Router, RouteRecordRaw } from 'vue-router'
import HomeView from './views/HomeView.vue'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

export const MainRoutes: RouteRecordRaw = {
  path: '/',
  name: 'home',
  component: HomeView,
  children: [],
  meta: {
    requiresAuth: true,
    layout: 'Default',
    title: 'داشبورد',
    showBackButton: false,
    requiredPermissions: [...MODULE_PERMISSIONS.dashboard],
  },
}

export const ProfileRoute: RouteRecordRaw = {
  path: '/profile',
  name: 'profile',
  component: () => import('./views/ProfileView.vue'),
  meta: {
    requiresAuth: true,
    layout: 'Default',
    title: 'بیشتر',
    contentFlushOnMobile: true,
    requiredPermissions: [...MODULE_PERMISSIONS.profile],
  },
}

export default (router: Router) => {
  router.addRoute(MainRoutes)
  router.addRoute(ProfileRoute)
}
